import { useState, useEffect } from "react";
import { FacematchAxiosClient } from "../../../Network/FacematchAxiosClient";

export default function useFaceMatchFetch(url, params = {}) {
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setData(null);
    setError(null);

    FacematchAxiosClient.get(url, {
      params,
    })
      .then((res) => {
        setLoading(false);
        //checking for multiple responses for more flexibility
        //with the url we send in.
        res.data && setData(res.data);
      })
      .catch((err) => {
        setLoading(false);
        setError(err.message);
      });
    return () => {};
  }, [url, params]);

  return { data, isLoading, error };
}
